module.exports = __webpack_public_path__ + "img/media.37c27da8.png";